export enum FilterQuality {
  none,
  low,
  medium,
  high,
}
